import React, { useState } from 'react'
import PropTypes from 'prop-types'
import IconCheck from '../../../img/icon-check.svg'
import IconQuestion from '../../../img/icon-question.svg'
import RequirementDetail from './RequirementDetail'
import SVGWrapper from '../SVGWrapper'

const ExemptionDetail = ({ exemption }) => {
    const [expanded, setExpanded] = useState(false)

    const {
        requirements: { spatial, project },
        isMet
    } = exemption

    return (
        <div className="exemption">
            <h6 className="exemption-title">
                <div
                    className="title is-6"
                    onClick={() => setExpanded(!expanded)}
                    onKeyDown={e => (e.key === 'Enter' ? setExpanded(!expanded) : null)}
                    role="button"
                    tabIndex="0"
                >
                    <div className={`status ${isMet === 'maybe' ? 'maybe' : ''}`}>
                        <span className="svg-icon icon-24">
                            {isMet === true && (
                                <SVGWrapper title="A check mark icon">
                                    <IconCheck />
                                </SVGWrapper>
                            )}
                            {isMet === 'maybe' && (
                                <SVGWrapper title="A question mark icon">
                                    <IconQuestion />
                                </SVGWrapper>
                            )}
                        </span>
                    </div>
                    <div className={`triangle ${expanded ? 'expanded' : 'collapsed'}`} />
                    {exemption.label}
                </div>
            </h6>
            {expanded && (
                <div className="exemption-detail">
                    <div className="description has-text-weight-bold" style={{ marginTop: '10px' }}>
                        {exemption.notes}
                    </div>
                    {spatial.length > 0 && (
                        <div className="requirements">
                            <h6 className="title is-6 is-normal is-italic">
                                Site Check considered the following requirements:
                            </h6>
                            {spatial.map(requirement => (
                                <React.Fragment key={requirement.id || requirement.label.split(' ').join('')}>
                                    <RequirementDetail type="spatial" requirement={requirement} />
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                    {project.length > 0 && (
                        <div className="requirements">
                            <h6 className="title is-6 is-normal is-italic">
                                User must determine the remaining requirements:
                            </h6>
                            {project.map(requirement => (
                                <React.Fragment key={requirement.label.split(' ').join('')}>
                                    <RequirementDetail type="project" requirement={requirement} />
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

ExemptionDetail.propTypes = {
    exemption: PropTypes.shape({}).isRequired
}

export default ExemptionDetail
